import React from 'react';
import { Animated } from 'react-animated-css';
import { Link } from 'react-router';
import Menu from '../partials/menu';
import TopRightMenu from '../partials/top_right_menu';
import LineLoader from '../partials/line_loader';
import { Popover, PopoverBody } from 'reactstrap';
import _ from 'lodash';

class Settings extends React.Component {
    state = {
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        new_charge_name: '',
        new_rate_name: '',
        new_rate_code: '',
        editing: null,
        edit_name: '',
        editing_rate: null,
        edit_rate_name: '',
        validations: {},
        microSaving: false,
    }

    componentWillMount() {
        const { id } = this.props.params;
        if (id) {
            this.props.settings_actions && this.props.settings_actions.fetch_charge_types(id);
            this.props.settings_actions && this.props.settings_actions.fetch_rate_types(id);
        }
    }

    componentWillReceiveProps = nextProps => {
        const { charge_types, rate_types } = nextProps;
        this.setState({ charge_types, rate_types });
    }

    onAddChargeType = () => {
        const { new_charge_name } = this.state;
        const { id } = this.props.params;
        if (!new_charge_name.trim()) {
            this.setState({ validations: { new_charge_name: 'Introduce el nombre del tipo de cargo' } });
            return;
        }
        this.setState({ microSaving: true, validations: {} }, () => {
            this.props.settings_actions && this.props.settings_actions.create_charge_type(id, new_charge_name.trim());
            this.setState({ new_charge_name: '', microSaving: false });
        });
    }

    onSaveEdit = () => {
        const { editing, edit_name } = this.state;
        const { id } = this.props.params;
        if (!edit_name.trim()) return;
        this.props.settings_actions && this.props.settings_actions.update_charge_type(editing, edit_name.trim(), id);
        this.setState({ editing: null, edit_name: '' });
    }

    onDelete = (ct) => {
        const { id } = this.props.params;
        this.props.settings_actions && this.props.settings_actions.delete_charge_type(ct.IdChargeType, id);
    }

    // Rate types
    onAddRateType = () => {
        const { new_rate_name, new_rate_code } = this.state;
        const { id } = this.props.params;
        if (!new_rate_name.trim()) {
            this.setState({ validations: { new_rate_name: 'Introduce el nombre del tipo de tarifa' } });
            return;
        }
        if (!new_rate_code.trim()) {
            this.setState({ validations: { new_rate_code: 'Introduce el código (ej: RACK_DESAYUNO)' } });
            return;
        }
        this.setState({ validations: {} }, () => {
            this.props.settings_actions && this.props.settings_actions.create_rate_type(id, new_rate_name.trim(), new_rate_code.trim().toUpperCase().replace(/\s+/g, '_'));
            this.setState({ new_rate_name: '', new_rate_code: '' });
        });
    }

    onSaveRateEdit = () => {
        const { editing_rate, edit_rate_name } = this.state;
        const { id } = this.props.params;
        if (!edit_rate_name.trim()) return;
        this.props.settings_actions && this.props.settings_actions.update_rate_type(editing_rate, edit_rate_name.trim(), id);
        this.setState({ editing_rate: null, edit_rate_name: '' });
    }

    onDeleteRate = (rt) => {
        const { id } = this.props.params;
        this.props.settings_actions && this.props.settings_actions.delete_rate_type(rt.IdRateType, id);
    }

    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_settings blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Configuración</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 align-self-center d-flex">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }

    renderChargeTypes = () => {
        const { charge_types, new_charge_name, editing, edit_name, validations, microSaving } = this.state;

        return <div className="mt-4">
            <span className="white poppins font-16">Tipos de Cargos</span>
            <p className="whiteish font-10 poppins mt-1">Define los conceptos disponibles al agregar cargos en reservaciones.</p>

            {/* ADD NEW */}
            <div className="d-flex mt-3" style={{ maxWidth: 500 }}>
                <div id="new_charge_name" className={`black-input bg-gray-2 d-flex flex-grow-1 ${validations.new_charge_name ? 'error-input' : ''}`}>
                    <input
                        className="w-100 p-3 white"
                        type="text"
                        placeholder="Nuevo tipo de cargo..."
                        value={new_charge_name}
                        onChange={e => this.setState({ new_charge_name: e.target.value, validations: {} })}
                        onKeyPress={e => e.key === 'Enter' && this.onAddChargeType()}
                    />
                </div>
                <button onClick={this.onAddChargeType} disabled={microSaving} className="btn btn-blue white ms-2 px-4">
                    {microSaving ? <i className="fas fa-cog fa-spin" /> : <i className="fas fa-plus" />}
                </button>
                <Popover placement="right" isOpen={validations.new_charge_name ? true : false} target="new_charge_name"
                    toggle={() => this.setState({ validations: {} })} className="bg-gray-2">
                    <PopoverBody className="d-flex flex-row">
                        <i className="fas fa-times red font-8 align-self-center" />
                        <span className="white font-8 poppins align-self-center ms-2">{validations.new_charge_name}</span>
                    </PopoverBody>
                </Popover>
            </div>

            {/* LIST */}
            <div className="mt-3" style={{ maxWidth: 500 }}>
                {!charge_types && <LineLoader />}
                {charge_types && charge_types.length === 0 && <span className="whiteish font-10 poppins">No hay tipos de cargo configurados.</span>}
                {charge_types && charge_types.map((ct, i) => (
                    <div key={ct.IdChargeType} className="d-flex black-input bg-gray-2 mb-2 px-3" style={{ height: 50 }}>
                        {editing === ct.IdChargeType ? (
                            <>
                                <input
                                    className="w-100 white bg-transparent border-0"
                                    value={edit_name}
                                    autoFocus
                                    onChange={e => this.setState({ edit_name: e.target.value })}
                                    onKeyPress={e => e.key === 'Enter' && this.onSaveEdit()}
                                />
                                <button onClick={this.onSaveEdit} className="btn btn-link green ms-2">
                                    <i className="fas fa-check" />
                                </button>
                                <button onClick={() => this.setState({ editing: null })} className="btn btn-link white ms-1">
                                    <i className="fas fa-times" />
                                </button>
                            </>
                        ) : (
                            <>
                                <span className="blue poppins align-self-center font-10 me-3" style={{ minWidth: 32 }}>{String(ct.Code || 0).padStart(3, '0')}</span>
                                <span className="white poppins align-self-center font-12 flex-grow-1">{ct.Name}</span>
                                <button onClick={() => this.setState({ editing: ct.IdChargeType, edit_name: ct.Name })}
                                    className="btn btn-link whiteish ms-2" title="Editar">
                                    <i className="fas fa-pencil-alt font-10" />
                                </button>
                                <button onClick={() => this.onDelete(ct)}
                                    className="btn btn-link red ms-1" title="Eliminar">
                                    <i className="fas fa-trash font-10" />
                                </button>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    }

    renderRateTypes = () => {
        const { rate_types, new_rate_name, new_rate_code, editing_rate, edit_rate_name, validations } = this.state;

        return <div className="mt-4">
            <span className="white poppins font-16">Tipos de Tarifa</span>
            <p className="whiteish font-10 poppins mt-1">Define los tipos de tarifa disponibles para esta propiedad (ej: RACK, WALK-IN, CORPORATIVA).</p>

            {/* ADD NEW */}
            <div className="d-flex mt-3" style={{ maxWidth: 600 }}>
                <div id="new_rate_name" className={`black-input bg-gray-2 d-flex flex-grow-1 ${validations.new_rate_name ? 'error-input' : ''}`}>
                    <input
                        className="w-100 p-3 white"
                        type="text"
                        placeholder="Nombre (ej: RACK CON DESAYUNO)"
                        value={new_rate_name}
                        onChange={e => this.setState({ new_rate_name: e.target.value, validations: {} })}
                        onKeyPress={e => e.key === 'Enter' && this.onAddRateType()}
                    />
                </div>
                <div id="new_rate_code" className={`black-input bg-gray-2 d-flex ms-2 ${validations.new_rate_code ? 'error-input' : ''}`} style={{ width: 200 }}>
                    <input
                        className="w-100 p-3 white"
                        type="text"
                        placeholder="Código (ej: RACK_DESAYUNO)"
                        value={new_rate_code}
                        onChange={e => this.setState({ new_rate_code: e.target.value.toUpperCase().replace(/\s+/g, '_'), validations: {} })}
                        onKeyPress={e => e.key === 'Enter' && this.onAddRateType()}
                    />
                </div>
                <button onClick={this.onAddRateType} className="btn btn-blue white ms-2 px-4">
                    <i className="fas fa-plus" />
                </button>
                <Popover placement="right" isOpen={validations.new_rate_name ? true : false} target="new_rate_name"
                    toggle={() => this.setState({ validations: {} })} className="bg-gray-2">
                    <PopoverBody className="d-flex flex-row">
                        <i className="fas fa-times red font-8 align-self-center" />
                        <span className="white font-8 poppins align-self-center ms-2">{validations.new_rate_name}</span>
                    </PopoverBody>
                </Popover>
            </div>

            {/* LIST */}
            <div className="mt-3" style={{ maxWidth: 600 }}>
                {!rate_types && <LineLoader />}
                {rate_types && rate_types.length === 0 && <span className="whiteish font-10 poppins">No hay tipos de tarifa configurados.</span>}
                {rate_types && rate_types.map((rt, i) => (
                    <div key={rt.IdRateType} className="d-flex black-input bg-gray-2 mb-2 px-3" style={{ height: 50 }}>
                        {editing_rate === rt.IdRateType ? (
                            <>
                                <input
                                    className="w-100 white bg-transparent border-0"
                                    value={edit_rate_name}
                                    autoFocus
                                    onChange={e => this.setState({ edit_rate_name: e.target.value })}
                                    onKeyPress={e => e.key === 'Enter' && this.onSaveRateEdit()}
                                />
                                <button onClick={this.onSaveRateEdit} className="btn btn-link green ms-2">
                                    <i className="fas fa-check" />
                                </button>
                                <button onClick={() => this.setState({ editing_rate: null })} className="btn btn-link white ms-1">
                                    <i className="fas fa-times" />
                                </button>
                            </>
                        ) : (
                            <>
                                <span className="blue poppins align-self-center font-10 me-3" style={{ minWidth: 120 }}>{rt.Code}</span>
                                <span className="white poppins align-self-center font-12 flex-grow-1">{rt.Name}</span>
                                <button onClick={() => this.setState({ editing_rate: rt.IdRateType, edit_rate_name: rt.Name })}
                                    className="btn btn-link whiteish ms-2" title="Editar">
                                    <i className="fas fa-pencil-alt font-10" />
                                </button>
                                <button onClick={() => this.onDeleteRate(rt)}
                                    className="btn btn-link red ms-1" title="Eliminar">
                                    <i className="fas fa-trash font-10" />
                                </button>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    }

    render() {
        return <section>
            <div style={{ marginLeft: 100 }}>
                <div className="container-fluid px-4 pt-4">
                    {this.renderHeader()}
                    <hr className="border-gray" />
                    <Animated animationIn="fadeIn" animateOnMount={true} animationInDuration={300} isVisible={true}>
                        {this.renderRateTypes()}
                        <div style={{ height: 30 }} />
                        {this.renderChargeTypes()}
                    </Animated>
                </div>
            </div>
            <Menu {...this.props} />
        </section>
    }
}

export default Settings;
